export default __webpack_public_path__ + "static/media/Shared-Image-ARTIGOS-SYS-03.24fbc661.jpg";